<div class="gift-notes">
  @for (note of notes; track note.number) {
    <multi-shipment-entry-card-preview
      [number]="note.number"
      [title]="note.title"
      [chips]="note.chips"
      [rows]="note.rows"
      (removePressed)="giftNoteRemoved.emit()"></multi-shipment-entry-card-preview>
  }

  @if (canAddGiftNote) {
    <multi-shipment-add-card-preview
      [card]="addCard"
      (actionPressed)="giftNoteAdded.emit()"></multi-shipment-add-card-preview>
  }
</div>
